import React from 'react';
import { TYING_STEPS, PRO_TIPS } from '../data/siteContent';

export const TyingGuide = () => (
  <div className="space-y-8">
    <p className="text-lg text-gray-700">
      Tying a bow tie may seem intimidating at first, but with practice, it becomes second nature. Follow these classic steps:
    </p>

    <div className="space-y-6">
      {TYING_STEPS.map((step, i) => (
        <div key={step.title} className="flex gap-4">
          <div className="flex-shrink-0 w-12 h-12 bg-[#7B1E2B] rounded-full flex items-center justify-center text-white font-bold text-lg">
            {i + 1}
          </div>
          <div>
            <h4 className="font-semibold text-lg text-[#001B2A] mb-2">{step.title}</h4>
            <p className="text-gray-700">{step.description}</p>
          </div>
        </div>
      ))}
    </div>

    <div className="bg-[#E6D7B3]/30 border-2 border-[#E6D7B3] rounded-lg p-6 mt-8">
      <h4 className="font-serif font-bold text-lg text-[#001B2A] mb-3">Pro Tips from The Bow Tie Guy:</h4>
      <ul className="space-y-2 text-gray-700">
        {PRO_TIPS.map((tip) => (
          <li key={tip} className="flex items-start gap-2">
            <span className="text-[#7B1E2B] font-bold">•</span>
            <span>{tip}</span>
          </li>
        ))}
      </ul>
    </div>

    <div className="bg-gradient-to-r from-[#001B2A] to-[#7B1E2B] text-white p-6 rounded-lg text-center">
      <p className="text-lg font-serif italic">
        "The art of tying a bow tie is a skill that connects you to centuries of tradition and style."
      </p>
      <p className="mt-3 text-sm">- Johnnie Mayo, The Bow Tie Guy</p>
    </div>
  </div>
);
